import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../components/customTable/CustomTable";
import { IconButton, Tooltip, Box, Typography, Card } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
// import { partnerTransactionApi } from "../../app/slices/partnerTransaction/partnerTransactionSlice";
import Swal from "sweetalert2";
import { partnerTransactionApi } from "../../app/slices/partnerInvoice/partnerTransactionSlice";
import { border } from "@mui/system";
import { useSearchParams } from "react-router-dom";

export default function AllTransaction({ id }) {
  const dispatch = useDispatch();
  const [partnerCode] = useSearchParams();
  const partnerUsername = partnerCode.get("partnerUsername");

  const now = new Date();
  const [monthYear, setMonthYear] = useState({
    month: now.getMonth() + 1,
    year: now.getFullYear(),
  });

  const [loading, setLoading] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);
  const [partnerSummary, setPartnerSummary] = useState(null);
  console.log(partnerSummary?.invoiceUrl, "partnerSummary");
  const fetchTransactions = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await dispatch(
        partnerTransactionApi({
          _id: id,
          month: monthYear.month,
          year: monthYear.year,
        }),
      );
      console.log(response, "shubham>>>>>>>>>>>>");
      if (response.meta.requestStatus === "fulfilled") {
        const payloadData = response.payload?.data;
        setPartnerSummary(payloadData || null);

        if (
          !payloadData?.allTransactions ||
          payloadData.allTransactions.length === 0
        ) {
          setTransactionsData([]);
          Swal.fire({
            text: "No transaction found",
            timer: 5000,
            showConfirmButton: false,
          });
        } else {
          setTransactionsData(payloadData.allTransactions);
        }
      }
    } catch (error) {
      console.log("error fetching partner transactions: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, monthYear]);

  const handleMonthYearChange = (value) => {
    setMonthYear(value);
  };

  // ---- Same mapping convention as ShowTransactionModal.jsx ----
  const sliceResponseData = transactionsData?.map((item) => ({
    id: item._id || "-",
    price: item.Price || "-",
    amount: item.amount || "-",
    clientId: item.client_id?._id || "-",
    clientName: item.client_id?.name || "-",
    commission: item.commission || "-",
    subcommission: item.sub_partner_commission || "-",
    createdAt: item.createdAt || "-",
    subPartner: item.sub_partner_id?.name || "-",
    customerRefNo: item.customerRefNo || item.proposal_no || "-",
    partner_comm_per: item.partner_comm_per || "-",
    gst: item.gst || "-",
    invoiceNo: item.invoice_No || "-",
    invoiceUrl: item.invoice_url || "-",
    merchantTransactionId: item.merchant_transaction_id || "-",
    metalType: item.metal_type || "-",
    orderId: item.orderID || "-",
    partnerId: item.partner_id || "-",
    paymentId: item.payment_id || "-",
    paymentMethod: item.payment_method || "-",
    proposalId: item.proposal_id || "-",
    quantity: item.quantity || "-",
    status: item.status || "-",
    totalAmount: item.total_amount || "-",
    transactionId: item.transaction_id || "-",
    preTaxAmount: item.preTaxAmount || "-",
    refinery: item.refinery || "-",
    updatedAt: item.updatedAt || "-",
  }));

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("clientId", {
      header: "Client Name",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.clientId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.clientId}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.clientName || "Batuk Customer"}
            </div>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("refinery", {
      header: "Refinery",
      size: 30,
      Cell: ({ row }) => {
        const refinery = row.original?.refinery;

        return refinery
          ? refinery.charAt(0).toUpperCase() + refinery.slice(1).toLowerCase()
          : "N/A";
      },
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
      Cell: ({ row }) => {
        const metalType = row.original?.metalType;

        return metalType
          ? metalType.charAt(0).toUpperCase() + metalType.slice(1).toLowerCase()
          : "N/A";
      },
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: (cell) => cell.row.original?.quantity || "N/A",
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.totalAmount || "N/A",
    }),
    columnHelper.accessor("price", {
      header: "Price",
      size: 30,
      Cell: (cell) => cell.row.original?.price || "N/A",
    }),
    columnHelper.accessor("commission", {
      header: "Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.commission || "N/A",
    }),
    columnHelper.accessor("subcommission", {
      header: "Sub-Partner Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.subcommission || "N/A",
    }),
    columnHelper.accessor("invoiceNo", {
      header: "Invoice No",
      size: 30,
      Cell: (cell) => cell.row.original?.invoiceNo || "N/A",
    }),
    columnHelper.accessor("invoiceUrl", {
      header: "Invoice URL",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoiceUrl);
          toast.success("URL copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.invoiceUrl}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("customerRefNo", {
      header: "Proposal No",
      size: 30,
      Cell: (cell) => cell.row.original?.customerRefNo || "N/A",
    }),

    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partnerId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partnerId}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {partnerUsername}
            </div>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("proposalId", {
    //   header: "Proposal ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.proposalId);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.proposalId}>
    //         <div style={{ display: "flex", alignItems: "center" }}>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.proposalId}
    //         </div>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("subPartner", {
      header: "Sub Partner",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.subPartner}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt?.split("T")[0]}
        </div>
      ),
    }),

    columnHelper.accessor("preTaxAmount", {
      header: "Pre Tax Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.preTaxAmount || "N/A",
    }),

    // columnHelper.accessor("partner_comm_per", {
    //   header: "Partner Commission",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.partner_comm_per || "N/A",
    // }),
    columnHelper.accessor("gst", {
      header: "GST",
      size: 30,
      Cell: (cell) => cell.row.original?.gst || "N/A",
    }),
    // columnHelper.accessor("paymentMethod", {
    //   header: "Payment Method",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.paymentMethod || "N/A",
    // }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: (cell) => cell.row.original?.status || "N/A",
    }),

    // columnHelper.accessor("updatedAt", {
    //   header: "Updated At",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original.updatedAt?.split("T")[0]}
    //     </div>
    //   ),
    // }),
  ];
  const cardStyle = {
    minWidth: 260,
    flex: 1,
    p: 2,
    borderRadius: 3,
    border: "1px solid #E0E0E0",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
  };
  return (
    <>
      {partnerSummary && (
        <Box mb={2} display="flex" gap={2} flexWrap="wrap">
          <Card sx={cardStyle}>
            <Typography variant="subtitle2">Partner</Typography>
            <Typography variant="h6" fontWeight={600}>
              {partnerSummary.name}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              ({partnerSummary.username})
            </Typography>
          </Card>
          <Card sx={cardStyle}>
            <Typography variant="subtitle2">Total Commission</Typography>
            <Typography variant="h5">
              ₹{" "}
              {Number(partnerSummary.totalCommission || 0).toLocaleString(
                "en-IN",
              )}
            </Typography>
          </Card>

          <Card sx={cardStyle}>
            <Typography variant="subtitle2">Total Pre-Tax Amount</Typography>
            <Typography variant="h5">
              ₹{" "}
              {Number(partnerSummary.totalPreTaxAmount || 0).toLocaleString(
                "en-IN",
              )}
            </Typography>
          </Card>
        </Box>
      )}

      <CustomTable
        columns={columns}
        data={sliceResponseData}
        loading={loading}
        showMonthYearPicker={true}
        onMonthYearChange={handleMonthYearChange}
        permissionKey="PartnerAllTransactions"
        partnerInvoiceUrl={partnerSummary?.invoiceUrl}
      />
    </>
  );
}
